/* Custom pure event delegation & .closest() functions.*/
EventTarget.prototype.delegateListener=function(b,c,d){let a=a=>{let b;[].slice.call(this.querySelectorAll(c)).reverse().filter(b=>b.contains(a.target)).forEach(c=>{(void 0===b|| !1!==b)&&(b=d.call(c,a))})};return this.addEventListener(b,a),a};function closest(a,b){do if(b(a))return a;while(a=a&&a.parentNode)}

window.Custom = window.Custom || {};

(function ($) {
  "use strict";

  
Custom = {
  container: document.querySelector(`body`),

  mobileBreakpoint: "868px",

  init: function() {
    // BASE
    this.setElementHeight();
    this.fontSize();
    this.setScrollAttributes();
    this.localizationPopup();
    this.initHeightEqualizer();

    if(document.querySelector('.sticky--button .button')) {
      document.querySelector('.sticky--button .button').addEventListener('click', function () {
        const targetElement = document.querySelector('[type="submit"].product-form__submit');
        console.log(targetElement);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    }
     
    document.querySelectorAll('[data-trigger], [href="#add"]').forEach(button => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
          let targetSelector = this.getAttribute('data-trigger');
          if(this.getAttribute("href") == "#add") {
            targetSelector = "button[name='add']";
          }
          const targetElement = document.querySelector(targetSelector);

          if (targetElement) {
              targetElement.click();
          }
      });
    });
    
    window.off = Element.prototype.off = function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    };
    
    window.on = Element.prototype.on = function(event, callback, options){
      if( !this.namespaces )
        this.namespaces = {};
  
      this.namespaces[event] = callback;
      options = options || false;
  
      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    };
    
    this.iniDropdown();
  },

  initHeightEqualizer: function() {
    this.applyHeightEqualization();
    setTimeout(() => {
      this.applyHeightEqualization()
    }, 1500);
    window.addEventListener('resize', () => this.applyHeightEqualization());
  },

  applyHeightEqualization: function() {
    document.querySelectorAll('section').forEach(section => {
      if(section.querySelector(".slider--wrapper")) {
        section.querySelectorAll(".slider--wrapper").forEach(wrapper => {
          this.equalizeHeight(wrapper);
          this.setHeightVariable(wrapper);
        });
      } else {
        this.equalizeHeight(section);
        this.setHeightVariable(section);
      }
    });
  },

  equalizeHeight: function(section) {
    const equalHeightElements = section.querySelectorAll('[data-height="equal"]');
    if (equalHeightElements.length > 0) {
      let maxHeight = 0;
      equalHeightElements.forEach(element => {
        element.style.height = 'auto';
        maxHeight = Math.max(maxHeight, element.offsetHeight);
      });

      if (maxHeight > 20) {
        section.style.setProperty('--element-heights', `${maxHeight}px`);
      }
    }
  },

  setHeightVariable: function(section) {
    const setHeightElement = section.querySelector('[data-height="set"]');
    if (setHeightElement) {
      const height = setHeightElement.offsetHeight;
      // console.log(setHeightElement, height);
      if (height > 20) {
        section.style.setProperty('--element-height', `${height}px`);
      }
    }
  },
  
  closeAllPopups: function(current) {
    let popups = document.querySelectorAll(".popup--wrapper");
    popups.forEach((el) => {
      if(el !== current) {
        el.setAttribute("data-active", "false");
      }
      
    });
  },
  
  localizationPopup: function() {
    this.container.delegateListener("click", ".custom-localization button", function(e) {
      e.preventDefault();
      let _this = event.target.closest(".custom-localization");
      let popup = _this.querySelector(".popup--wrapper");
      
      this.closeAllPopups(popup);
      popup.setAttribute("data-active", (popup.getAttribute("data-active") == "false"));
    }.bind(this));

    this.container.delegateListener("click", ".custom-localization .popup--wrapper", function(e) {

      let _this = event.target;
      let popup = _this.closest(".custom-localization").querySelector(".popup--wrapper");

      if(!_this.closest(".popup--inner")) {
        popup.setAttribute("data-active", (popup.getAttribute("data-active") == "false"));
      }
    }.bind(this));
  },
  
  iniDropdown() {
    var selectors = {
      trigger: `[data-dropwdown="trigger"]`,
      module: `[data-dropwdown="body"]`,
      moduleInner: '.dropdown--inner',
      tabs: '.collapsible-trigger--tab'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };
  
    var namespace = `.list--unset`;
  
    var isTransitioning = false;
  
    var el = document;
    el.querySelectorAll(selectors.trigger).forEach(trigger => {
      var state = trigger.classList.contains(classes.open);
      trigger.setAttribute('aria-expanded', state);
      trigger.off('click' + namespace);
      trigger.on('click' + namespace, toggle);
    });
    
    document.addEventListener("reload_dropdowns", function(event) {
      document.querySelectorAll(selectors.trigger).forEach(trigger => {
          var state = trigger.classList.contains(classes.open);
          trigger.setAttribute('aria-expanded', state);
          trigger.removeEventListener('click', toggle); // Remove previous event listener
          trigger.addEventListener('click', toggle); // Add event listener
      });
    });
    
    function toggle(evt) {
      if (isTransitioning) {
        return;
      }
  
      isTransitioning = true;
  
      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
  
      if (!moduleId) {
        moduleId = el.dataset.controls;
      }
      
      if (!moduleId) {
        return;
      }
      
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }
  
      if (!container) {
        isTransitioning = false;
        return;
      }
  
      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;
  
      if (isTab) {
        if(isOpen) {
          isTransitioning = false;
          return;
        }
  
        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="'+ el.dataset.id +'"]').forEach(el => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, 0, true);
        });
      }
      
      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }
  
      if (isOpen && !isAutoHeight) {
        height = 0;
      }
  
      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
        if(el.querySelector("span").textContent == "Read Less") {
          el.classList.remove("hide");
          el.querySelector("span").textContent = "Read More";
        }
      } else {
        el.classList.add(classes.open);
        if(el.querySelector("span").textContent == "Read More") {
          el.classList.add("hide");
          el.querySelector("span").textContent = "Read Less";
        }
      }
  
      setTransitionHeight(container, height, isOpen, isAutoHeight);
      
      if (parentCollapsibleEl) {
        var parentHeight = parentCollapsibleEl.style.height;
  
        if (isOpen && parentHeight === 'auto') {
          childHeight = 0;
        }
  
        var totalHeight = isOpen ? parentCollapsibleEl.offsetHeight - childHeight : height + parentCollapsibleEl.offsetHeight;
  
        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }
    }
  
    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      prepareTransition(container, function() {
        container.style.height = height+'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });
  
      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }

    function prepareTransition(el, callback) {
      el.addEventListener('transitionend', removeClass);
  
      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }
  
      el.classList.add('is-transitioning');
      el.offsetWidth;
  
      if (typeof callback === 'function') {
        callback();
      }
    }
  },
  
  getDistanceToParentBottom : function(element) {
    let elementRect = element.getBoundingClientRect();
    let parentRect = element.parentElement.getBoundingClientRect();
    let distanceToParentBottom = parentRect.bottom - elementRect.bottom;
    return distanceToParentBottom;
  },
  
  setElementHeight : function() {
    const elementHeight = (event) => {
      document.querySelectorAll("[data-height^='target']").forEach((el) => { 
        let container = el.closest("[data-height='container']");
        let name = el.getAttribute("data-height").split("/")[1];
        if(name) {
          document.documentElement.style.setProperty(`--${ name }`, el.clientHeight + "px");
        } else {
          container.style.setProperty('--element_height', el.clientHeight + 'px');
          if(!container.classList.contains("height-set")) {
            container.classList.add("height-set");
          }
        }
      });
      
    }
    window.addEventListener("resize", elementHeight);
    window.addEventListener("load", elementHeight);
  },

  setScrollAttributes: function() {  
    let lastScrollTop = 0;
    
    const handleScroll = (event) => {
      let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      this.container.setAttribute("data-scrollDirection", (currentScroll > lastScrollTop ? "down" : "up"));
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
      
      this.container.setAttribute("data-scrolled", window.scrollY > 0);
      
    };
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("load", handleScroll);
  },

  setStickyElement: function(selector) {
    const elements = document.querySelectorAll(selector);
    let distance;
    
    this.checkScrollPosition(elements, this.header.clientHeight);
    window.addEventListener("scroll", () => {
      this.checkScrollPosition(elements, this.header.clientHeight);
    });
  },

  checkScrollPosition: (elements, header) => {
    let distance;
    let elementHeight;
    
    elements.forEach(function(element) {
      distance = window.pageYOffset + element.getBoundingClientRect().top;
      distance = element.getBoundingClientRect().top - header;
      elementHeight = element.clientHeight;

      element.style.paddingTop = distance <= 0 ? `${ elementHeight }px` : 0;
      element.setAttribute("data-sticky", distance <= 0);
    });
  },

  setInputValue: function(event, callback) {
    let self = event.target;
    let container = self.parentElement;
    let input = container.querySelector("input");
    let min = parseInt(input.getAttribute("min"));
    let current = parseInt(input.value);
    let max = parseInt(input.getAttribute("max"));

    input.value = self.classList.contains("plus") ? (current < max ? current + 1 : max) : (current > min ? current - 1 : min);

    if(self.classList.contains("minus") && current === min) {
      //callback(input.value);
    }

    callback(input.value);
    
    input.dispatchEvent(new Event('input', { 'bubbles': true }));
  },

  handlelize: function(str) {
    str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/([^\w]+|\s+)/g, '-')
      .replace(/\-\-+/g, '-')
      .replace(/(^-+|-+$)/g, '')
      .toLowerCase();
  
    return str
  },

  fontSize: function() {
    function adjustFontSize() {
      const elements = document.querySelectorAll('[data-font]');

      elements.forEach(element => {
        const elementWidth = element.offsetWidth;
        
        const fontData = element.getAttribute('data-font').split('/');
        const baseFontSize = parseFloat(fontData[0]) || 10;
        const baseContainerWidth = parseFloat(fontData[1]) || 1280;
        
        let newFontSize = (elementWidth / baseContainerWidth) * baseFontSize;

        if(newFontSize >= 16) {
          newFontSize = 16;
        }
        element.style.fontSize = newFontSize + 'px';
      });
    }

    window.addEventListener('load', () => {
      adjustFontSize();
      setTimeout(adjustFontSize, 1500);
      // setTimeout(adjustFontSize, 2000);
      setTimeout(adjustFontSize, 3000);
    });
                

    window.addEventListener('resize', adjustFontSize);
  }
};

Custom.init();

})();



class SliderElement extends HTMLElement {
  connectedCallback() {
    const settings = this.getAttribute('data-settings');
    const parsedSettings = settings ? JSON.parse(settings) : {};
    const arrowNextButtons = [];
    const arrowPrevButtons = [];

    const swiperContainer = this.querySelector('.swiper');
    let parentSection = this.closest('section');
    if(this.closest("media-gallery") || this.closest(".media-gallery")) {
      parentSection = this;
    }
    
    const paginationElement = parentSection ? parentSection.querySelector('.swiper-pagination') : null;
    const scrollbarElement = parentSection ? parentSection.querySelector('.swiper-scrollbar') : null;
    
    const nextButton = parentSection ? parentSection.querySelector('.swiper-button-next') : null;
    const prevButton = parentSection ? parentSection.querySelector('.swiper-button-prev') : null;
    
    const nextButton2 = parentSection ? parentSection.querySelector('.swiper-button-next2') : null;
    const prevButton2 = parentSection ? parentSection.querySelector('.swiper-button-prev2') : null;
    
    if(nextButton && prevButton) {
      arrowNextButtons.push(nextButton);
      arrowPrevButtons.push(prevButton);
    }
    
    if(nextButton2 && prevButton2) {
      arrowNextButtons.push(nextButton2);
      arrowPrevButtons.push(prevButton2);
    }
    
    const defaultSettings = {
      loop: true,
      spaceBetween: 10,
      autoplay: {
        delay: 8000,
      },
      navigation: {
        nextEl: arrowNextButtons,
        prevEl: arrowPrevButtons,
      },
    };

    if (paginationElement) {
      defaultSettings.pagination = {
        el: paginationElement,
        clickable: true
      };
    }

    if(parsedSettings.thumbs) {
      parsedSettings.thumbs.swiper = this.closest('section').querySelector(".slider-thumbs .swiper");
    }
    
    if (scrollbarElement) {
      defaultSettings.scrollbar = {
        el: scrollbarElement,
        draggable: true
      };
    }
    
    // console.log(parentSection, defaultSettings, parsedSettings);
    
    const swiperSettings = { ...defaultSettings, ...parsedSettings };

    new Swiper(swiperContainer, swiperSettings);

    this.addDataIdClickHandler();
    // this.removeAttribute('data-settings')
  }

  
  addDataIdClickHandler() {
    
  }
}

customElements.define('slider-element', SliderElement);

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-snippet='tooltip']").forEach(tooltipWrapper => {
    tooltipWrapper.addEventListener("mouseenter", () => 
      tooltipWrapper.setAttribute("data-active", "true")
    );

    tooltipWrapper.addEventListener("mouseleave", () => 
      tooltipWrapper.removeAttribute("data-active")
    );
  });
});

class BGGIntegration extends HTMLElement {
  static cache = {};
  static requestQueue = [];
  static isRequesting = false;

  connectedCallback() {
    const id = this.getAttribute("data-id");
    this.ratingElement = this.querySelector("span");

    if (!id || !this.ratingElement) return;

    this.loadGameRating(id);
  }

  async loadGameRating(gameId) {
    let ratings = this.getStoredRatings();

    if (ratings[gameId]) {
      this.ratingElement.textContent = ratings[gameId];
      this.ratingElement.classList.add("visible");
      return;
    }

    if (BGGIntegration.cache[gameId]) {
      this.ratingElement.textContent = BGGIntegration.cache[gameId];
      this.ratingElement.classList.add("visible");
      return;
    }

    BGGIntegration.requestQueue.push({ gameId, element: this });

    if (!BGGIntegration.isRequesting) {
      this.processQueue();
    }
  }

  async processQueue() {
    if (BGGIntegration.requestQueue.length === 0) {
      BGGIntegration.isRequesting = false;
      return;
    }

    BGGIntegration.isRequesting = true;
    const { gameId, element } = BGGIntegration.requestQueue.shift();

    const rating = await element.fetchGameRating(gameId);

    if (rating) {
      element.ratingElement.textContent = rating;
      this.ratingElement.classList.add("visible");
      let ratings = element.getStoredRatings();
      ratings[gameId] = rating;
      element.saveRatings(ratings);
      BGGIntegration.cache[gameId] = rating;
    } else {
      element.classList.add("hide");
    }

    setTimeout(() => {
      element.processQueue();
    }, 5000);
  }

  async fetchGameRating(gameId) {
    const proxyUrl = `https://api.allorigins.win/get?url=${encodeURIComponent(`https://boardgamegeek.com/xmlapi/boardgame/${gameId}&stats=1`)}`;

    try {
      const response = await fetch(proxyUrl);
      const data = await response.json();

      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(data.contents, "text/xml");

      const averageRating = xmlDoc.querySelector("statistics ratings average")?.textContent;
      return averageRating ? parseFloat(averageRating).toFixed(1) : null;
    } catch (error) {
      console.error("Error fetching game data:", error);
      return null;
    }
  }

  getStoredRatings() {
    try {
      return JSON.parse(localStorage.getItem("bgg_ratings")) || {};
    } catch {
      return {};
    }
  }

  saveRatings(ratings) {
    localStorage.setItem("bgg_ratings", JSON.stringify(ratings));
  }
}

customElements.define("bgg-integration", BGGIntegration);


class QuizElement extends HTMLElement {
  constructor() {
    super();
    this.sections = this.querySelectorAll(".element-section");
    this.currentIndex = 0;
    this.totalSteps = this.sections.length - 1;
    this.quizIndex = this.dataset.quiz;
    this.header = this.querySelector(".element-header");
    this.progressBar = this.querySelector(".element-headerProgress div");
    this.loadingOverlay = this.querySelector(".element-loading");
    this.backButton = this.querySelector(".element-headerButton button");
    this.cartButton = this.querySelector(".element-cart");
    this.stepsWrapper = this.querySelector(".element-headerSteps > span");
    this.currentStepSpan = this.querySelector("[data-current]");
    this.category = localStorage.getItem("selectedQuizId") || "";
    this.responses = JSON.parse(localStorage.getItem("quizResponses")) || {};
    this.responsesFull = JSON.parse(localStorage.getItem("quizResponsesFull")) || {};
    this.emailSectionIndex = parseInt(document.querySelector(".section-email").dataset.index);
  }

  connectedCallback() {
    this.initializeQuiz();
    this.klaviyoForm();
    
    window.addEventListener("hashchange", () => this.loadFromHash());
    this.delegateListener("change", `#checkobx-subs`, (e) => {
      let checked = e.target.checked;

      document.querySelectorAll(`[data-section="quiz_products"] .element-price`).forEach((el) => {
        let discountPrice = el.querySelector(".discounted");
        let defaultPrice = el.querySelector(".default");
        let badgeElement = el.querySelector(".element-badge");

        discountPrice.classList.toggle("hide");
        defaultPrice.classList.toggle("hide");
        badgeElement.classList.toggle("hide");
      });

      document.querySelectorAll(".sub-element").forEach((el) => {
        el.classList.toggle("hide");
      });
    });
    
    this.delegateListener("click", `[data-section="quiz_products"] button`, (e) => {
      this.productCartButton(e);
    });
  }

  initializeQuiz(index = 0) {
    this.loadFromHash(index, true);
    this.populateInputs();
    this.updateProgress();
    this.addNavigation();
  }

  loadFromHash(ind, event = false) {
    let match = window.location.pathname.match(/^\/pages\/[^/]+\/([^#/]+)/);
    let urlParams = match ? match[1] : "";
    let index = parseInt(window.location.hash.replace("#step-", ""), 10) || ind;
    
    if (urlParams && !urlParams.includes('=')) {
      index = this.totalSteps;
    }

    if (urlParams) {
      index = this.totalSteps;
    }
    
    if (isNaN(index) || index < 0 || index > this.totalSteps) {
      index = 0;
    }

    this.toggleSection(this.currentIndex, index);
    this.currentIndex = index;
    this.updateProgress();

    if((this.emailSectionIndex - 1) === this.currentIndex) {
      this.populateFormInputs(document.querySelector(".section-email"));
    }
    
    if (this.currentIndex === this.totalSteps) {
      if (!event) {
        return;
      }
      this.fetchResultsPage();
    }
  }

  collectResponses(index) {
    let inputs = this.sections[index].querySelectorAll("input[name]");
    
    inputs.forEach((input) => {
      let name = input.name;
      if (input.type === "checkbox") {
        if (!this.responses[name] || !Array.isArray(this.responses[name])) {
          this.responses[name] = [];
        }

        if ((input.type === "checkbox" && input.checked) || (input.type === "text" && input.value.trim() !== "")) {
          if (!this.responses[name].includes(input.value)) {
            this.responses[name].push(input.value);
          }
        } else {
          this.responses[name] = this.responses[name].filter(val => val !== input.value);
        }

        if (this.responses[name].length === 0) {
          delete this.responses[name];
        }
      } else if (input.type === "hidden") {
        this.responses[name] = input.value.replace(".", "_");
      
      } else if (input.type === "text") {
        if (!this.responses[name] || !Array.isArray(this.responses[name])) {
          this.responses[name] = [];
        }

        if ((input.type === "text" && input.value.trim() !== "")) {
          if (!this.responses[name].includes(input.value)) {
            this.responses[name].push(input.value);
          }
        } else {
          this.responses[name] = this.responses[name].filter(val => val !== input.value);
        }

        if (this.responses[name].length === 0) {
          delete this.responses[name];
        }
      } else if (input.type === "radio" && input.checked) {
        this.responses[name] = input.value;
      }
    });

    localStorage.setItem("quizResponses", JSON.stringify(this.responses));
  }

  populateInputs() {
    Object.keys(this.responses).forEach((name) => {
      let inputs = this.querySelectorAll(`[name='${name}']`);
      inputs.forEach((input, index) => {
        if (input.type === "radio") {
          input.checked = this.responses[name] === input.value;
        } else {
          let values = this.responses[name] || [];
          input.value = values[index].replace("_", ".") || "";
        }
      });
    });
  }

  getParamsFromUrl() {
    let match = window.location.pathname.match(/^\/pages\/[^/]+\/([^#/]+)/);
    let paramsString = match ? match[1] : "";
    let params = new URLSearchParams(paramsString);
    let urlResponses = {};

    for (let [key, value] of params.entries()) {
      if (value.includes("+")) {
        urlResponses[key] = value.split("+");
      } else {
        urlResponses[key] = value;
      }
    }

    return urlResponses;
  }

  toggleSection(fromIndex, toIndex) {
    console.log(this.sections[toIndex].classList);
    if(this.sections[toIndex].classList.contains("section-email") || this.sections[toIndex].classList.contains("section-results")) {
      let userQuizData = this.responsesFull
      let queryParams = new URLSearchParams();
      Object.keys(this.responses).forEach((key) => {
        let value = this.responses[key];
        queryParams.append(key, Array.isArray(value) ? value.join("+") : value);
      });

      queryParams = queryParams.toString();

      // klaviyo.identify({
      //    'Quiz URL' : "https://masi.eu/pages/longevity-quiz/" + queryParams,
      //     ...userQuizData
      // });
      
      if(this.sections[toIndex].innerText.includes("Thanks for subscribing!")) {
        location.reload();
      }
    }

    if (this.sections[fromIndex]) this.sections[fromIndex].dataset.active = "false";
    if (this.sections[toIndex]) this.sections[toIndex].dataset.active = "true";
  }

  updateProgress() {
    let progress = ((this.currentIndex + 1 - 1) / (this.totalSteps + 1 - 1)) * 100;
    this.progressBar.style.width = `${progress}%`;
    this.currentStepSpan.innerHTML = `${(this.currentIndex + 1)}/${this.totalSteps}`;
    this.currentStepSpan.classList.remove("hide");
    this.backButton.classList.remove("hide");
    this.backButton.nextElementSibling.classList.add("hide");
    this.cartButton.classList.add("hide");
    this.header.classList.remove("style--results");
    
    if (this.currentIndex === this.totalSteps) {
      this.backButton.classList.add("hide");
      this.cartButton.classList.remove("hide");
      this.backButton.nextElementSibling.classList.remove("hide");
      this.header.classList.add("style--results");
      this.currentStepSpan.innerHTML = `<button id="product-section" type="button" class="button--primary">žaidimai</button>`;
    }

    if (this.currentIndex == 0) {
      this.backButton.classList.add("hide");
      this.currentStepSpan.classList.add("hide");
    }
  }

  addNavigation() {
    const backButton = this.querySelector("[data-button='back']");
    if (backButton) {
      backButton.addEventListener("click", () => this.prevSection());
    }
        
    this.sections.forEach((section, index) => {
      if (section.classList.contains("section-results") || section.classList.contains("section-dashboards")) return;

      if (section.querySelector(`[data-type="Single Option"]`)) {
        section.querySelectorAll(`[data-type="Single Option"] input`).forEach((el) => {
          el.addEventListener("click", (e) => {
            this.nextSection(index);
          });
        });
        return;
      }

      let nextButton = section.querySelector(".next-button");
      if (!nextButton) {
        nextButton = document.createElement("button");
        nextButton.classList.add("next-button", "button-primary");
        nextButton.textContent = "Next";
        nextButton.addEventListener("click", () => this.nextSection(index));
        section.querySelector(".section--inner .element-button").appendChild(nextButton);
      } else {
        nextButton.addEventListener("click", () => this.nextSection(index));
      }
    });

    this.delegateListener("click", `[data-section="quiz_hero"] button`, () => {
      this.querySelector(`[data-section="quiz_blocks"]`).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    });
    
    this.delegateListener("click", `#product-section`, () => {
      const quizSection = this.querySelector(`[data-section="quiz_products"]`);
      const header = this.querySelector(`[data-section="quiz-element"] > header`);
      
        const headerHeight = header ? header.offsetHeight : 0;
        const sectionTop = quizSection.getBoundingClientRect().top + window.scrollY;
        
        window.scrollTo({
          top: sectionTop - headerHeight,
          behavior: "smooth",
        });
    });
    
    this.delegateListener("click", `.element-cart`, () => {
      document.querySelector("#cart-icon-bubble").click()
    });
  }

  populateFormInputs(section) {
    const quizResponses = JSON.parse(localStorage.getItem("quizResponses")) || {};
    const inputs = section.querySelectorAll("input[type='email']");
    
    inputs.forEach((input) => {
        const name = input.placeholder.replaceAll(" ", "_").toLowerCase();
        if (quizResponses[name]) {
          input.value = quizResponses[name];
          const event = new Event("input", { bubbles: true });
          input.dispatchEvent(event);
        }
    });
  }
  
  nextSection(index) {
    this.collectResponses(index);
    this.collectResponsesFull(index);

    if (this.currentIndex < this.totalSteps - 1) {
      this.updateHash(this.currentIndex + 1);
    } else if (this.currentIndex === this.totalSteps - 1) {
      this.fetchResultsPage(() => this.updateHash(this.currentIndex + 1));
    }
  }

  prevSection() {
    if (this.currentIndex > 0) {
      this.updateHash(this.currentIndex - 1);
    } else {
      window.location.replace(window.location.origin);
    }
  }

  updateHash(index) {
    window.location.hash = `#step-${index}`;
  }

  fetchResultsPage(callback) {
    let queryParams = new URLSearchParams();
    let urlResponses = this.getParamsFromUrl();

    this.backButton.dataset.hidden = Object.keys(urlResponses).length !== 0;
    // this.stepsWrapper.dataset.hidden = Object.keys(urlResponses).length !== 0;

    let storedResponses = JSON.parse(localStorage.getItem("quizResponses")) || {};
    this.responses = Object.keys(urlResponses).length > 0 ? urlResponses : storedResponses;

    if(this.responses["quiz"] != this.quizIndex) {
      localStorage.removeItem("quizResponses");
      localStorage.removeItem("quizResponsesFull");
      window.location.replace(location.href.match(/^https?:\/\/[^\/]+\/[^\/]+\/[^\/]+/)[0]);
      return;
    }
    
    Object.keys(this.responses).forEach((key) => {
      let value = this.responses[key];
      queryParams.append(key, Array.isArray(value) ? value.join("+") : value);
    });

    document.body.style.overflow = "hidden";

    this.loadingOverlay.classList.remove("hide");

    
    fetch(`${ (location.origin + window.Shopify.routes.root) }pages/results/${queryParams.toString()}`)
      .then(response => response.text())
      .then(html => {
        let resultsContainer = this.querySelector("[data-results]");
        if (resultsContainer) resultsContainer.innerHTML = html;
        if (callback) callback();
        setTimeout(() => {
          this.loadingOverlay.classList.add("hide");
          document.body.style.overflow = "visible";

        }, 2500);
        this.initResultsSections();
      })
      .catch(error => console.error("Error fetching results:", error));
  }
  
  initResultsSections(index) {
    document.querySelectorAll(`[data-section="quiz_blocks"] .grid--wrapper`).forEach((el) => {
      if(el.classList.contains("combined-section")) {
        let elOrder = parseInt(el.style.order) + 1;
        let nextSection = document.querySelector(`.element-sections > div[style*="order: ${ elOrder };"]`);
        el.querySelector(".element-combined").textContent = nextSection.querySelector(".text--wrapper").textContent;
        nextSection.classList.add("hide");
      }
    });
  }

  collectResponsesFull(index) {
    let inputs = this.sections[index].querySelectorAll("input[name]");

    inputs.forEach((input) => {
      if(input.closest(".section-email")) {
        return;
      }
      
      let name = input.closest(".element-section").querySelector("h2.heading").textContent.trim();
      if (input.type === "radio" && input.checked) {
        this.responsesFull[name] = input.nextElementSibling.textContent.trim();
      }
    });

    localStorage.setItem("quizResponsesFull", JSON.stringify(this.responsesFull));
  }
  
  klaviyoForm() {
    const formContainer = document.querySelector(".section-email .klaviyo-form-QYqhcp");
    const nextButton = document.querySelector(".section-email .element-button .next-button");
    
    if (formContainer && nextButton) {
      nextButton.style.display = "none";
      const observer = new MutationObserver((mutations, obs) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList") {
            const successMessage = formContainer.querySelector("h1");
            if (successMessage && successMessage.innerText.includes("Thanks for subscribing!") && nextButton.style.display != "block") {
                nextButton.style.display = "block";
              this.nextSection(formContainer.closest(".section-email").dataset.index);
              obs.disconnect();
            }
          }
        });
      });
      observer.observe(formContainer, { childList: true, subtree: true });
    }
  }

  cartAdd(formData, _this) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((response) => response.json())
    .then(response => {
      fetch(window.Shopify.routes.root + "?sections=cart-icon-bubble")
        .then((response) => response.json())
        .then((response) => {
          console.log(response);
          let selector = "#cart-icon-bubble2";
          let drawer = document.querySelector(selector);
          console.log(drawer, drawer.innerHTML);
          drawer.innerHTML = new DOMParser().parseFromString(response["cart-icon-bubble"], 'text/html').querySelector("#shopify-section-cart-icon-bubble").innerHTML;
          document.querySelector(".element-headerSteps .cart-count-bubble").classList.remove("hide");
          _this.classList.remove("button--loading");
        });
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  
  productCartButton(event) {
    let _this = event.target; 
    let id = _this.dataset.id; 
    let plan = _this.dataset.plan; 
    let productPrice = _this.dataset.price; 
    let items = {"id": id, "quantity": 1};
    let formData = {'items': [], "sections": "cart-data"};
    formData.items.push(items);
    _this.classList.add("button--loading");
    this.cartAdd(formData, _this);
  }
}

customElements.define("quiz-element", QuizElement);

class DynamicProducts extends HTMLElement {
  constructor() {
    super();
    this.debounceTimer = null;
    this.cache = new Map();
    this.type = "sku"
    this.debouncedLoadContent = debounce(this.loadContent.bind(this), 200);
  }
   
  connectedCallback() {
    this.ids = this.getAttribute("data-content");
    this.container = this.querySelector(".container");
    this.loadContent();
  }

  async loadContent() {
    if (!this.container || !this.ids) {
      console.error("Missing Data");
      return;
    }
    
    if (this.cache.has(this.ids)) {
      this.container.innerHTML = this.cache.get(this.ids);
      return;
    }
    
    const query = this.ids.split(",").map(item => encodeURIComponent(`"${item.trim()}"`)).join("+OR+");
    const fetchUrl = `/search?q=${query}&view=dynamic`;

    try {
      const response = await fetch(fetchUrl);
      if (response.ok) {
        const html = await response.text();
        this.cache.set(this.ids, html);
        this.container.innerHTML = html;
      } else {
        console.error("Failed to fetch slider content:", response.status);
      }
    } catch (error) {
      console.error("Error fetching slider content:", error);
    }
  }

  static get observedAttributes() {
    return ['data-content'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-content' && oldValue !== newValue) {
      this.ids = newValue;
      this.debouncedLoadContent();
    }
  }
  
  refresh() {
    this.debouncedLoadContent();
  }

  disconnectedCallback() {
    clearTimeout(this.debounceTimer);
  }
}

customElements.define("dynamic-products", DynamicProducts);

